import { makeAutoObservable } from "mobx";
import { ChangeEvent } from "react";
import {
  EmptyStudentResponseImpl,
  StudentResponseApi,
} from "../../DTO/ServerResponseType/Student/Student";
import studentServerClient from "../../ServerClients/StudentServerClient";
import { ObservableStudentPropImpl } from "../../DTO/ClientRequest/StudentRequest";
import { GroupWindowStore } from "./GroupWindowStore";

export class StudentStore {
  student: ObservableStudentPropImpl;
  root: GroupWindowStore;
  showPasswordInputWhenUpdate: boolean = false;
  studentOldName: string;
  copyPassword: string | null = null;

  constructor(root: GroupWindowStore) {
    let student = new EmptyStudentResponseImpl();
    this.studentOldName = student.studentName;

    this.student = new ObservableStudentPropImpl({
      name: student.studentName,
      password: student.studentPassword,
      studentId: student.studentId,
    });
    makeAutoObservable(this);
    this.root = root;
  }

  setStudent = (student: StudentResponseApi) => {
    this.student = new ObservableStudentPropImpl({
      name: student.studentName,
      password: student.studentPassword ?? null,
      studentId: student.studentId,
    });
    this.studentOldName = student.studentName;
    this.onPasswordInputClose();
    this.copyPassword = null;
  };

  get saveWindowTitle(): string {
    return this.student.studentId === ""
      ? "Добавить нового ученика"
      : "Изменение ученика " + this.studentOldName;
  }

  get saveButtonText(): string {
    return this.student.studentId === ""
      ? "Создать и добавить в группу"
      : "Сохранить";
  }

  onPasswordInputOpen = () => {
    this.showPasswordInputWhenUpdate = true;
    this.student.password = null;
    this.copyPassword = null;
  };

  onPasswordInputClose = () => {
    this.showPasswordInputWhenUpdate = false;
  };

  get showPasswordInput(): boolean {
    return (
      this.student.studentId === "" || this.showPasswordInputWhenUpdate === true
    );
  }

  async saveClickAsync() {
    console.log(this.student.password);
    console.log(this.copyPassword);
    if (this.student.password !== this.copyPassword)
      throw new Error("Пароли не совпадают");
    return (
      this.student.studentId === ""
        ? studentServerClient.sendToRegistrateStudentAsync({
            ...this.student,
            groupCode: this.root.group.groupCode,
          })
        : studentServerClient.sendToUpdateStudentAsync({
            ...this.student,
          })
    ).then(() => {
      this.root.root.groupsStore.loadAllGroupsAsync();
      this.root.studentsStore.loadAllStudentsAsync();
    });
  }

  onChangeName = (event: ChangeEvent<HTMLInputElement>) => {
    this.student.onChangeName(event.currentTarget.value);
  };

  onChangePassword = (event: ChangeEvent<HTMLInputElement>) => {
    this.student.onChangePassword(event.currentTarget.value);
  };

  onChangeCopyPassword = (event: ChangeEvent<HTMLInputElement>) => {
    this.copyPassword = event.currentTarget.value;
  };
}
